<div class="row">
  <div class="col-md-12">
    <div class="card ">
      <div class="row">
        <div class="col-md-12 mb-lg-0 mb-3">
          <h2 class="font-weight-bold">Add Address</h2>

          <form [formGroup]="noteForm" (ngSubmit)="submitForm()">
            <div class="row">
              <div class="col-lg-6 mb-3">
                <div class="form-group">
                  <label class="small white-space pb-1">Country</label>
                  <mat-form-field>
                    <mat-select formControlName="country" placeholder="Select country" class="form-control"
                      (selectionChange)="onCountrySelectionChange($event.value)">
                      <mat-option *ngFor="let country of countryList" [value]="country.id">
                        {{ country.country_name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-error *ngIf="
                        submitted && noteForm.get('country')!.errors?.required
                      ">
                    Country is required
                  </mat-error>
                </div>
              </div>
              <div class="col-lg-6 mb-3">
                <div class="form-group">
                  <label class="small white-space pb-1">Address</label>
                  <input type="text" class="form-control" placeholder="Address" formControlName="address_line_1" />
                  <mat-error *ngIf="
                        submitted &&
                        noteForm.get('address_line_1')!.errors?.required
                      ">
                    Address is required
                  </mat-error>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-6 mb-3">
                <div class="form-group">
                  <label class="small white-space pb-1">Unit/Apartment</label>
                  <input type="text" class="form-control" placeholder="Unit/Apartment" formControlName="unit" />
                  <mat-error *ngIf="
                        submitted && noteForm.get('unit')!.errors?.required
                      ">
                    Apartment is required
                  </mat-error>
                </div>
              </div>
              <div class="col-lg-6 mb-3">
                <div class="col">
                  <div class="form-group">

                    <div class="form-group d-flex align-items-center gap-2 mb-0">
                      <label class="small white-space pb-0 me-auto mb-0">Entry/Buzzer code</label>
                      <label class="small white-space pb-1 d-flex gap-2">No Buzzer Code <input type="checkbox"
                          (change)="toggleBuzzerCode($event)" /></label>

                    </div>
                    <input type="text" class="form-control" placeholder="Buzzer code" formControlName="buzzer_code" />
                  </div>
                </div>

              </div>
            </div>

            <div class="row">
              <div class="col-lg-6 mb-3">
                <div class="form-group">
                  <label class="small white-space pb-1">City</label>
                  <input type="text" class="form-control" placeholder="City" formControlName="city" />
                  <mat-error *ngIf="
                        submitted && noteForm.get('city')!.errors?.required
                      ">
                    City is required
                  </mat-error>
                </div>
              </div>
              <div class="col-lg-6 mb-3">
                <div class="form-group">
                  <label class="small white-space pb-1">Province</label>
                  <mat-form-field>
                    <mat-select formControlName="province" placeholder="Select province" class="form-control">
                      <mat-option *ngFor="let state of statlist" [value]="state.id">
                        {{ state.state_name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-error *ngIf="
                        submitted && noteForm.get('province')!.errors?.required
                      ">
                    Province is required
                  </mat-error>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-6 mb-3">
                <div class="form-group">
                  <label class="small white-space pb-1">Postal code</label>
                  <input type="text" class="form-control" placeholder="Postal code" formControlName="postal_code" />
                  <mat-error *ngIf="
                        submitted &&
                        noteForm.get('postal_code')!.errors?.required
                      ">
                    Postal code is required
                  </mat-error>
                </div>
              </div>
              <div class="col-lg-6 mb-3">
                <div class="form-group">
                  <label class="small white-space pb-1">Delivery Instructions</label>
                  <input type="text" class="form-control" placeholder="Delivery Instructions"
                    formControlName="delivery_instruction" />
                  <!-- <mat-error
                      *ngIf="
                        submitted &&
                        noteForm.get('delivery_instruction')!.errors?.required
                      "
                    >
                      Delivery Instructions are required
                    </mat-error> -->
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <button class="custom-btn mt-3 ml-0" type="submit">
                  Submit
                </button>
                <button class="custom-btn mt-3" type="button" (click)="this.dialogRef.close()">
                  Cancel
                </button>
              </div>
            </div>
          </form>

        </div>
      </div>
    </div>
  </div>
</div>